import React from 'react';
import { motion } from 'framer-motion';
import { personalInfo } from '../data/portfolio';
import { openCalendar } from '../utils/calendar';
import './Hero.css';

const Hero: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.2,
        duration: 0.5
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <motion.div
            className="hero-text"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              stiffness: 100,
              damping: 15,
              duration: 0.8
            }}
          >
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <motion.h1
                className="hero-title"
                variants={itemVariants}
              >
                <span className="highlight">{personalInfo.name}</span>
              </motion.h1>

              <motion.h2
                className="hero-subtitle"
                variants={itemVariants}
              >
                {personalInfo.title}
              </motion.h2>

              <motion.div
                className="hero-description"
                variants={itemVariants}
              >
                {personalInfo.description.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </motion.div>
              
              <motion.div
                className="hero-actions"
                variants={itemVariants}
              >
                <motion.button
                  onClick={openCalendar}
                  className="btn btn-outline"
                  whileHover={{ scale: 1.05, boxShadow: "0 5px 15px rgba(0,0,0,0.05)" }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                  <i className="fas fa-calendar-alt"></i> Prendre rendez-vous
                </motion.button>

                <motion.a
                  href={personalInfo.cvUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline"
                  whileHover={{ scale: 1.05, boxShadow: "0 5px 15px rgba(0,0,0,0.05)" }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                  <i className="fas fa-file-lines"></i> Voir le CV
                </motion.a>
              </motion.div>
            </motion.div>
          </motion.div>
          
          <motion.div
            className="hero-image"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              stiffness: 100,
              damping: 15,
              duration: 0.8,
              delay: 0.3
            }}
          >
            <motion.div
              className="image-container"
              whileHover={{
                scale: 1.05,
                rotate: 2,
                boxShadow: "0 10px 25px rgba(0,0,0,0.2)"
              }}
              transition={{ duration: 0.3 }}
            >
              <img
                src={typeof personalInfo.profileImage === 'string' ? personalInfo.profileImage : personalInfo.profileImage}
                alt={`Photo de ${personalInfo.name}`}
                className="profile-image"
              />
              <div className="image-overlay"></div>
            </motion.div>
          </motion.div>
        </div>
      </div>
      
    </section>
  );
};

export default Hero;